<template>
  <v-app style="background-color:#e0e0e0;margin-top:100px">
    <v-layout row wrap class="form-container">
      <v-flex xs12 sm12 md4>
        <v-card flat class="container">
          <strong>Delivery Address</strong>
          <p style="padding-top:10px">{{form.name}}</p>
          <p style="padding-top:10px">{{form.address}}</p>
          <p style="margin-top:-10px">{{form.cityDistrictTown}} - {{form.pinCode}},&nbsp;{{form.stateName}}</p>
          
          <strong style="padding-top:15px;">Phone number</strong>
          <p style="padding-top:0px">{{form.mobileNumber}}</p>
        </v-card>
      </v-flex>
      <v-flex xs12 sm12 md8 style="padding-left:10px;">
        <v-card flat class="container" style="height:245px">
          <strong>More Options</strong>
          <br/>
          <v-card-title v-if="form.delivered==false && form.cancelled==false">
            <span><span style="padding:5px;background-color:#1757C8;color:white;">₹</span>&nbsp;&nbsp;&nbsp;
            <span>Prefer contactless delivery ?</span>
            </span>
            <v-spacer></v-spacer>
            <v-btn small outline color="primary">Pay Now</v-btn>
          </v-card-title>
          <v-card-title>
            <span><span style="padding:5px;background-color:#EB5D55;color:white;">➣</span>&nbsp;&nbsp;&nbsp;
            <span>Share order details ?</span>
            </span>
            <v-spacer></v-spacer>
            <v-btn small outline color="primary">Share order</v-btn>
          </v-card-title>
        </v-card>
      </v-flex>

      <v-flex xs12 sm12 md8 style="padding-right:10px;margin-top:10px;">
          <v-card flat class="container">
            <v-stepper v-model="step" alt-labels class="elevation-0" v-if="form.cancelled==false">
          <v-stepper-header>
            <v-stepper-step style="text-align:center" step="1" :complete="step > 0">Ordered
              <p style="font-size:10px;text-align:center;color:green;" class="txt" v-if="form.ordered==true">
                {{form.date}}
              </p>
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="2" :complete="step > 1" class="step1">Packed
              <p style="font-size:10px;text-align:center;color:green;" class="txt" v-if="form.packed==true">
                {{form.pckDate}}
              </p>
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="3" :complete="step > 2">Shipped
              <p style="font-size:10px;text-align:center;color:green;" class="txt" v-if="form.shipped==true">
                {{form.shipDate}}
              </p>
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="4" :complete="step > 3">Delivered
              <p style="font-size:10px;text-align:center;color:green;" class="txt" v-if="form.delivered==true">
                {{form.deliverDate}}
              </p>
            </v-stepper-step>
          </v-stepper-header>
            </v-stepper>
            
            <v-stepper v-model="stepc" alt-labels class="elevation-0" v-if="form.cancelled==true">
          <v-stepper-header>
            <v-stepper-step style="text-align:center" step="1" :complete="stepc > 0">Ordered
              <p style="font-size:10px;text-align:center;color:green;" class="txt" v-if="form.ordered==true">
                {{form.date}}
              </p>
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step color="error" step="2" :complete="stepc > 4" class="step1">Cancelled
              <p style="font-size:10px;text-align:center;color:red;" class="txt" v-if="form.packed==true">
                {{form.cancelDate}}
              </p>
            </v-stepper-step>
          </v-stepper-header>
            </v-stepper>
          </v-card>
      </v-flex>

      <v-flex xs12 sm12 md4 style="margin-top:10px;">
        <v-card flat class="container" style="height:185px;" v-if="form.delivered==false && form.cancelled==false">
            <p style="font-weight:bold" class="txt" v-if="form.expectedDate!=null">
              Delivery expected by &nbsp;<span style="color:green">{{form.expDate}}</span>
            </p>

            <v-btn color="error" large depressed @click.stop="cancelDialog=true">
              <v-icon>cancel</v-icon>&nbsp;Cancel This Order
            </v-btn>
          </v-card>
      </v-flex>

      <v-flex xs12 style="margin-top:10px;">
            <v-card flat>
                <v-data-table :headers="headers" hide-actions :items="orderDetails" :search="search" :loading="false">
      <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
      <template slot="items" slot-scope="props">
        <tr v-if="form.company.shippingStateCode == form.stateCode">
          <td class="text-xs-left">
            <img height="70px" width="70px" style="padding:5px" :src=props.item.src />
            <p>{{props.item.itemName}}</p>
        </td>
        <td class="text-xs-left">₹ &nbsp;{{props.item.actualPrice.toFixed(2)}}</td>
        <td class="text-xs-left">{{props.item.hsnRate}}&nbsp;(%)</td>
        <td class="text-xs-left">{{props.item.cgst.toFixed(2)}}</td>
        <td class="text-xs-left">{{props.item.sgst.toFixed(2)}}</td>
        <td class="text-xs-left">0.00</td>
        <td class="text-xs-left">{{props.item.price.toFixed(2)}}</td>
        <td class="text-xs-left">{{props.item.quantity}}</td>
        <td class="text-xs-left">₹ &nbsp;{{props.item.totalPrice.toFixed(2)}}</td>
        </tr>

        <tr v-if="form.company.shippingStateCode != form.stateCode">
          <td class="text-xs-left">
            <img height="70px" width="70px" style="padding:5px" :src=props.item.src />
            <p>{{props.item.itemName}}</p>
        </td>
        <td class="text-xs-left">₹ &nbsp;{{props.item.actualPrice.toFixed(2)}}</td>
        <td class="text-xs-left">{{props.item.hsnRate}}&nbsp;(%)</td>
        <td class="text-xs-left">0.00</td>
        <td class="text-xs-left">0.00</td>
        <td class="text-xs-left">{{props.item.igst.toFixed(2)}}</td>
        <td class="text-xs-left">{{props.item.price.toFixed(2)}}</td>
        <td class="text-xs-left">{{props.item.quantity}}</td>
        <td class="text-xs-left">₹ &nbsp;{{props.item.totalPrice.toFixed(2)}}</td>
        </tr>
      </template>
      <v-alert
        slot="no-results"
        :value="true"
        color="error"
        icon="warning"
      >Your search for "{{ search }}" found no results.</v-alert>
                </v-data-table>
                <div style="background-color:#1976D2">
                    <h4 style="text-align:right;padding:15px;color:white">Total Amount :&nbsp;{{form.totalPrice.toFixed(2)}}</h4>
                </div>
                <div style="text-align:right">
                    <v-btn depressed color="warning" @click="back()">Back</v-btn>
                </div>
            </v-card>    
            </v-flex>
    </v-layout>

    <v-dialog v-model="cancelDialog" width="700px" persistent>
      <v-card class="container">
        <v-textarea v-model="form.cancelledRemarks" label="Give a reason for cancellation"></v-textarea>
        <div style="text-align:right">
                <v-btn small color="error" @click.stop="cancelDialog=false">Cancel</v-btn>
                <v-btn small color="primary" :loading="btnSave" @click="onSubmit()">Save</v-btn>
              </div>
      </v-card>
    </v-dialog>
  </v-app>
</template>


<script>
import config from "./../../config.json";
export default {
  data() {
    return {
        form: {},
        stepc: 5,
      orderDetails: [],
      step: 1,
      cancelDialog: false,
      btnSave: false,
      search: "",
      headers: [
        { text: "PRODUCT", value: "name" },
        { text: "Actual Price", value: "actualPrice" },
        { text: "HSN Rate", value: "hsnRate" },
        { text: "CGST", value: "cgst" },
        { text: "SGST", value: "sgst" },
        { text: "IGST", value: "igst" },
        { text: "Price", value: "price" },
        { text: "Qty", value: "quantity" },
        { text: "Total Price", value: "totalPrice" }
      ],
    };
  },

  mounted() {
      this.getData();
  },
  methods: {
      back() {
          this.$router.go(-1)
      },
      getData() {
        this.axios
        .get(config.API + `Orders/${this.$route.params.id}`, {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.form = res.data;
          this.step = res.data.step;
          this.orderDetails = res.data.orderDetails;
          this.$Progress.finish();
        });
      },
    onEdit(item) {
      this.$router.push(`/orderDetail/${item.id}`);
    },

    onDelete(item) {
      // alert(item.id);
      if (confirm("You want to delete this Address !!")) {
        this.axios
          .delete(config.API + `CustomerAddresses/${item.id}`, {
            headers: {
              Authorization: "bearer " + sessionStorage.getItem("token")
            }
          })
          .then(() => {
            this.$toaster.success("Deleted successfully");
            this.getData();
          })
          .catch(err => {
            this.$toaster.error(err.message);
          });
      }
    },

    onSubmit() {
      this.btnSave = true;
        this.axios
          .put(
            config.API + `CancelOrder/${this.$route.params.id}`,
            {
              id: JSON.parse(this.$route.params.id),  
              cancelledRemarks: this.form.cancelledRemarks
            },
            {
            headers: {
              Authorization: "bearer " + sessionStorage.getItem("token")
            }
          })
          .then(() => {
            this.$toaster.success("Cancelled successfully");
            this.getData();
            this.cancelDialog = false;
          })
          .catch(err => {
            this.$toaster.error(err.message);
          });
    },
  }
}
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Mulish&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Sora:wght@500&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@300&display=swap');
</style>
<style lang="css" scoped>
.covid {
  font-family: 'Quicksand', sans-serif;
  font-size: 12px;
  font-weight: bold;
}
.hdr {
 font-size: 50px;
 color: #e0e0e0;
}
.hdr1 {
 color: #e0e0e0;
}
.txt {
 font-family: 'Mulish', sans-serif;
}
.txtt {
 font-family: 'Sora', sans-serif;
}
.lftsid {
  background-color: black !important;
  background-size: cover;
  box-shadow: none !important;
  border-radius: 0px !important;
  height: 350px;
}
.login-form {
  padding: 40px;
}
.bckcolor {
  background-image: url("../../assets/loginbg.jpg");
  background-size: cover;
}
.cursr {
  cursor: pointer;
}
.v-btn {
  margin-left: 0px;
}
.txt_dec:hover {
    text-decoration: underline !important;
}
.loginPage {
  background-size:cover
}
.call-button-container {
  margin: auto;
  width: 233px;
  height: 74px;
  vertical-align: middle;
  padding: 10px;
}
@media screen and (max-width: 768px) {
  .res {
    display: none;
  }
}
@media screen and (min-width: 768px){
  .man {
    display: none;
  }
}
img.center {
    display: block;
    margin: 0 auto;
}
.step1 {
  text-align: center !important;
}
</style>
